import { render } from "./NewNews2.vue?vue&type=template&id=57f67c90&scoped=true"
import script from "./NewNews2.vue?vue&type=script&lang=js"
export * from "./NewNews2.vue?vue&type=script&lang=js"

import "./NewNews2.vue?vue&type=style&index=0&id=57f67c90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f67c90"]])

export default __exports__